// import * as fromActions from './actions/types'

const reducer = (state, action) => {
  return state
}

export default reducer
